<template>
  <div class="choose-level-banner">
    <div class="banner-title">{{ $t('choose_your_hsk_level') }}</div>
    <div class="banner-desc">{{ $t('choose_your_hsk_level_desc') }}</div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.choose-level-banner {
  height: 37vh;
  background: url('@/assets/images/chooselevel/banner-bg.png') no-repeat right center;
  background-size: 100% 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 16px;
  font-family: Calibri;

  & > .banner-title {
    color: #fff;
    font-size: 56px;
  }
  & > .banner-desc {
    color: #fff;
    font-size: 18px;
  }
}

@media (max-width: 768px) {
  .choose-level-banner {
    background-size: auto 100%;
    padding-bottom: 50px;
    // height: 464px;
    
    & > .banner-title {
      // mix-blend-mode: difference;
      font-size: 32px;
    }

    & > .banner-desc {
      padding: 0 5%;
      // mix-blend-mode: difference;
    }
  }
}
</style>
